export class Modifier {
    constructor(modifier) {
        this.is_selected = false;
        this.id = modifier.id;
        this.title = modifier.title;
        this.status = modifier.status;
        this.created_at = modifier.created_at;
        this.updated_at = modifier.updated_at;
        this.modifier_name = modifier.modifier.modifier_name;
        this.type = modifier.modifier.type;
        this.required = modifier.modifier.required;
        this.details = modifier.modifier.details ? this.getDetailList(modifier.modifier.details) : [];
    }

    getDetailList(detail) {
        let arr = [];
        for(let i = 0; i < detail.length; i++) {
            arr.push(new ModifierOption(detail[i]));
        }
        return arr;
    }

    changeStatusSelected() {
        this.is_selected = !this.is_selected;
    }

    changeStatusFalse() {
        this.is_selected = false;
    }

    changeStatusTrue() {
        this.is_selected = true;
    }
}

class ModifierOption {
    constructor(option) {
        this.id = option.id;
        this.name = option.name;
        this.price = option.price;
    }
}
